import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { offerConsent } from '@/analytics';
import { noticeLanguage } from '@/analytics/copy';
import { SITE_PAGES } from '@/config/site-pages';

/**
 * The cookie notice, on the home page only: in the editor it would sit on the
 * phone's tool bar, and someone mid-edit is the wrong person to ask.
 */
export function useConsentNotice(): void {
  const { i18n } = useTranslation();
  const lang = noticeLanguage(i18n.language);
  useEffect(() => offerConsent(lang, `${SITE_PAGES.privacy[lang]}#analytics`), [lang]);
}
